import styled, { css } from 'styled-components'
import { color, unit, size, fontWeight } from 'ui/themes/utils'

import Div from 'ui/elements/Div'
import RadioGroup from 'ui/blocks/RadioGroup'

export const Picker = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${unit('2')};

  container-type: inline-size;
`

export const Portal = styled.div`
  position: relative;

  grid-column: span 1;

  @media screen and (max-width: 576px) {
    .DayPicker-NavBar [class*="NavigationPrevious"],
    .DayPicker-NavBar [class*="NavigationNext"] {
      padding: 0 ${size('padding', 'md')};
    }
  }
`

export const Section = styled(Div)`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  gap: ${unit('2')};

  padding: ${unit('6')};

  background-color: ${color('Background/Primary')};

  border-radius: ${unit('2')};

  box-shadow: ${size('shadow', 'sm')};

  [class^='Field']:not(:first-child) {
    margin-left: auto;
  }

  ${({ gap }) => gap && css`
    justify-content: flex-start;

    gap: ${unit(gap)};
  `}

  ${({ disabled }) => disabled && css`
    pointer-events: none;

    background-color: ${color('Secondary/Background1')};

    opacity: 0.4;
  `}

  ${({ disableStyling }) => disableStyling && css`
    border: none;

    padding: 0;

    box-shadow: none;
  `}
`

export const Durations = styled(Section)`
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: max-content;

  column-gap: ${unit('5')};

  &.no-times {
    @container (min-width: 490px) {
      grid-template-columns: minmax(150px, 20%) 1fr;
      align-items: end;

      ${Portal} {
        grid-column: span 2;
      }
    }
  }

  @container (min-width: 690px) {
    grid-template-columns: minmax(200px, 20%) 1fr;
    align-items: end;

    ${Portal} {
      grid-column: span 2;
    }
  }
`

export const Timeslots = styled(Section)`
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: max-content;

  [class^='Field']:not(:first-child) {
    margin-left: 0;
  }

  @container (min-width: 450px) {
    grid-template-columns: repeat(2, 1fr);

    [class^='Field']:not(:first-child) {
      margin-left: auto;
    }

    ${Portal} {
      grid-column: span 2;
    }
  }
`

export const Period = styled(Section)`
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: max-content;

  [class*='Decorator'] {
    display: none;
  }

  [class^='Field']:not(:first-child) {
    margin-left: 0;
  }

  &.no-times {
    @container (min-width: 310px) {
      grid-template-columns: 1fr min-content 1fr;

      [class*='Decorator'] {
        display: flex;
      }

      [class^='Field']:not(:first-child) {
        margin-left: auto;
      }

      ${Portal} {
        grid-column: span 3;
      }
    }
  }

  @container (min-width: 550px) {
    grid-template-columns: 1fr min-content 1fr;

    [class*='Decorator'] {
      display: flex;
    }

    [class^='Field']:not(:first-child) {
      margin-left: auto;
    }

    ${Portal} {
      grid-column: span 3;
    }
  }
`

export const FulfillmentTypeSelect = styled.div`
  width: 100%;

  ${RadioGroup} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    gap: ${size('margin')};

    ${RadioGroup.Radio} {
      border: 1px solid ${color('Misc/Divider')};

      &[data-tid="Checked true"] {
        background-color: ${color('Primary/Background2')};
        border-color: ${color('Primary/Base')};

        box-shadow: inset 0 0 0 1px ${color('Primary/Base')};
      }
    }
  }
`

export const Error = styled.div`
  display: flex;
  align-items: center;

  gap: ${unit('2')};

  margin: 0 -${unit('6')};
  margin-top: -${unit('6')};
  /* We don't have a unit for 10px spacing :'( */
  padding: 10px ${unit('4')};

  background-color: ${color('Warning/Base')};
  color: ${color('Warning/Foreground1')};

  border-top-left-radius: ${unit('2')};
  border-top-right-radius: ${unit('2')};

  svg {
    width: 14px;

    fill: ${color('Warning/Foreground1')};
  }
`

export const PeriodReset = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  gap: ${unit('1')};

  appearance: none;
  border: none;
  background-color: transparent;

  cursor: pointer;

  position: absolute;

  bottom: 0;
  right: 0;

  color: ${color('Text/Tertiary')};

  font-size: 16px;
  font-weight: ${fontWeight('normal')};

  &:hover {
    color: ${color('Text/Primary')};
  }
`
